import React from 'react';
import { Phone, User } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { COUNTRIES, LANGUAGES } from '../inquiry/constants';

export const InquiryStep1 = ({ errors, formData, handleChange }) => (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-3">
          <User className="w-6 h-6 text-white" />
        </div>
        <h3 className="font-semibold text-lg">Personal Information</h3>
        <p className="text-sm text-gray-500">Tell us about yourself</p>
      </div>

      <div className="space-y-3">
        <div>
          <Label htmlFor="full_name">Full Name *</Label>
          <Input
            id="full_name"
            placeholder="Enter your full name"
            value={formData.full_name}
            onChange={(e) => handleChange('full_name', e.target.value)}
            className={errors.full_name ? 'border-red-500' : ''}
            data-testid="inquiry-name"
          />
          {errors.full_name && <p className="text-xs text-red-500 mt-1">{errors.full_name}</p>}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <Label htmlFor="email">Email Address *</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={formData.email}
              onChange={(e) => handleChange('email', e.target.value)}
              className={errors.email ? 'border-red-500' : ''}
              data-testid="inquiry-email"
            />
            {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
          </div>
          <div>
            <Label htmlFor="phone">Phone/WhatsApp *</Label>
            <Input
              id="phone"
              placeholder="+1 234 567 8900"
              value={formData.phone}
              onChange={(e) => handleChange('phone', e.target.value)}
              className={errors.phone ? 'border-red-500' : ''}
              data-testid="inquiry-phone"
            />
            {errors.phone && <p className="text-xs text-red-500 mt-1">{errors.phone}</p>}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <Label htmlFor="country">Country *</Label>
            <Select value={formData.country} onValueChange={(v) => handleChange('country', v)}>
              <SelectTrigger className={errors.country ? 'border-red-500' : ''} data-testid="inquiry-country">
                <SelectValue placeholder="Select country" />
              </SelectTrigger>
              <SelectContent>
                {COUNTRIES.map(c => (
                  <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
            {errors.country && <p className="text-xs text-red-500 mt-1">{errors.country}</p>}
          </div>
          <div>
            <Label htmlFor="language">Preferred Language</Label>
            <Select value={formData.language} onValueChange={(v) => handleChange('language', v)}>
              <SelectTrigger data-testid="inquiry-language">
                <SelectValue placeholder="Select language" />
              </SelectTrigger>
              <SelectContent>
                {LANGUAGES.map(l => (
                  <SelectItem key={l.value} value={l.value}>{l.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </div>
);
